export default [
  {
    path: '/eap_user_index',
    name: 'eap_user_index',
    component: (resolve) => require(['@/modules/eap/pages/user/index'], resolve),
    meta: {
      title: '用户管理'
    }
  },
  {
    path: '/eap_cache_index',
    name: 'eap_cache_index',
    component: (resolve) => require(['@/modules/eap/pages/cache/index'], resolve),
    meta: {
      title: '缓存管理'
    }
  },
  {
    path: '/eap_team_index',
    name: 'eap_team_index',
    component: (resolve) => require(['@/modules/eap/pages/team/index'], resolve),
    meta: {
      title: '组织管理'
    }
  },
  {
    path: '/eap_role_index',
    name: 'eap_role_index',
    component: (resolve) => require(['@/modules/eap/pages/role/index'], resolve),
    meta: {
      title: '角色管理'
    }
  },
  {
    path: '/eap_dict_index',
    name: 'eap_dict_index',
    component: (resolve) => require(['@/modules/eap/pages/dict/index'], resolve),
    meta: {
      title: '字典管理'
    }
  },
  {
    path: '/eap_menu_index',
    name: 'eap_menu_index',
    component: (resolve) => require(['@/modules/eap/pages/menu/index'], resolve),
    meta: {
      title: '菜单管理'
    }
  },
  {
    path: '/eap_log_index',
    name: 'eap_log_index',
    component: (resolve) => require(['@/modules/eap/pages/log/index'], resolve),
    meta: {
      title: '日志管理'
    }
  },
  {
    path: '/eap_config_index',
    name: 'eap_config_index',
    component: (resolve) => require(['@/modules/eap/pages/config/index'], resolve),
    meta: {
      title: '配置管理'
    }
  }
];
